import React, { FormEvent, useState } from 'react';
import moment from 'moment';
import { Button, Form, Input, InputGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';

interface IProps {
    timeFilter: boolean;
    handleDates: (e: FormEvent) => void;
    date: { start_date: string, end_date: string };
    setDate: (type: string, date: string) => void;
    handleCancel: () => void;
};

function DateFilter({
    timeFilter,
    handleDates,
    date,
    setDate,
    handleCancel
}: IProps) {

    const [openModal, setOpenModal] = useState(false);
    const toggleOpenModal = () => setOpenModal(!openModal);

    return (
        <React.Fragment>
            {timeFilter ? <React.Fragment>
                <Button color="secondary" size="sm" onClick={toggleOpenModal}>Select Date <i className="fas fa-calendar-week"></i></Button>
                <Modal isOpen={openModal} toggle={toggleOpenModal} className={''}>
                    <ModalHeader toggle={toggleOpenModal}>Select Date</ModalHeader>
                    <ModalBody className="pt-0">
                        <Form className="form" onSubmit={(e) => { handleDates(e) }}>
                            <InputGroup>
                                <Input
                                    id="exampleDate"
                                    name="date"
                                    placeholder="date placeholder"
                                    type="date"
                                    min="2021-01-01"
                                    max={moment().format('YYYY-MM-DD')}
                                    value={date?.start_date}
                                    onChange={(e) => {
                                        // setStartDate(e.target.value);
                                        // dispatch(setStartDateFilter(e.target.value));
                                        // console.log(e.target.value);
                                        // setDate({ ...date, start_data: e.target.value });
                                        setDate("start_date", e.target.value)
                                    }}
                                />
                            </InputGroup>
                            <InputGroup>
                                <Input
                                    id="exampleDate"
                                    name="date"
                                    placeholder="date placeholder"
                                    type="date"
                                    className="mt-2"
                                    min={date?.start_date}
                                    max={moment().add(1, 'd').format('YYYY-MM-DD')}
                                    value={date?.end_date}
                                    onChange={(e) => {
                                        // setEndDate(e.target.value);
                                        // dispatch(setEndDateFilter(e.target.value));
                                        // console.log(e.target.value);
                                        // setDate({ ...date, end_date: e.target.value });
                                        setDate("end_date", e.target.value)
                                    }}
                                />
                            </InputGroup>
                            <div className="mt-2 d-flex justify-content-end">
                                <Button
                                    color="secondary"
                                    onClick={() => {
                                        handleCancel();
                                        toggleOpenModal();
                                    }}
                                    className="mr-2"
                                >Cancel</Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className=""
                                >Search</Button>
                            </div>
                        </Form>
                    </ModalBody>
                    {/* <ModalFooter>
                        <Button color="secondary" onClick={toggleOpenModal}>Ok</Button>
                    </ModalFooter> */}
                </Modal>
            </React.Fragment> : <></>}
        </React.Fragment>
    )
}

export default React.memo(DateFilter);